export var supportedWixlocales = [
    'en',
    'en-US',
    'en-GB',
    'en-AU',
    'en-CA',
    'ar',
    'bg',
    'ca',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-MO',
    'cs',
    'da',
    'nl',
    'fi',
    'fr',
    'fr-CA',
    'fr-CH',
    'fr-BE',
    'de',
    'de-CH',
    'de-AT',
    'el',
    'he',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'ms',
    'no',
    'nb',
    'nn',
    'pl',
    'pt-BR',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'es',
    'es-419',
    'es-AR',
    'es-MX',
    'es-US',
    'sv',
    'tl',
    'th',
    'tr',
    'uk',
    'vi',
];
//# sourceMappingURL=constants.js.map